import { useSectionPathById } from '~/composables/useSectionConfigById';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function useProductSectionPath() {
    const { $subSectionRegistry } = useNuxtApp();
    const { country, lang } = useLanguage();
    const countryLanguages = useCountryLanguages();
    const fachportalPath = useSectionPathById('fachportal');

    const productMountPath = computed<string | null | undefined>(() => {
        const mount = ($subSectionRegistry.value ?? []).find(
            (sectionConfig) =>
                sectionConfig.professionalPortalProductMount === true && sectionConfig.country === country.value
        );

        return mount ? resolveSectionPath(mount, lang.value, countryLanguages) : undefined;
    });

    return computed(() => (productMountPath.value === undefined ? fachportalPath.value : productMountPath.value));
}

export function useRequiredProductSectionPath() {
    const sectionPath = useProductSectionPath();

    return computed(() => {
        if (sectionPath.value === null) {
            throw new Error(
                '[requiredSectionPath:useRequiredProductSectionPath] Product section path could not be resolved'
            );
        }

        return sectionPath.value;
    });
}
